<template>
  <a-button type="link" size="small" :class="JobLevelRadio.classObject" @click.stop="handleStaffList(level)">
    {{ JobLevelRadio.text }}
  </a-button>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'
export default {
  name: 'JobLevelRadio',
  props: {
    level: {
      type: [String, Number],
      default: ''
    },
    keywordsType: {
      type: [String, Number],
      default: ''
    },
    isSearch: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      'staffList', // 經銷列表
      'searchStaffParams'
    ]),
    JobLevelRadio () {
      let data = {}
      console.log(this.level)
      switch (this.level) {
        case 1:
          data = {
            text: '主任',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': this.keywordsType === 1 }
            ]
          }
          break
        case 2:
          data = {
            text: '高级主任',
            classObject: [
              'search__btn--done',
              'mr-1',
              {
                'search__filter--done':
                  this.keywordsType === 2
              }
            ]
          }
          break
        case 3:
          data = {
            text: '经理',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': this.keywordsType === 3 }
            ]
          }
          break
        case 4:
          data = {
            text: '高级经理',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': this.keywordsType === 4 }
            ]
          }
          break
        case 5:
          data = {
            text: '总监',
            classObject: [
              'search__btn--done',
              { 'search__filter--done': this.keywordsType === 5 }
            ]
          }
          break
        case 6:
          data = {
            text: '6',
            classObject: [
              'search__btn--done',
              { 'search__filter--done': this.keywordsType === 6 }
            ]
          }
          break
        default:
          data = {
            text: '全部',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': !this.keywordsType }
            ]
          }
          break
      }
      return data
    }
  },
  methods: {
    handleStaffList (level) {
      const params = this.searchStaffParams
      params.job_level = level
      params.page = 1
      if (this.isSearch) {
        this.$store.dispatch('getStaffList', params)
      } else {
        this.$emit('on-select', level)
      }
    }
  }
}
</script>
<style scoped lang="less">
/* search btn */
.search {
  &__btn {
    &--done {
      padding-top: 0.125rem;
      border-color: @dark-secondary !important;
      color: @dark-secondary !important;
      border-radius: 3px;

      &:hover {
        border-color: lighten(@dark-secondary, 8%) !important;
        color: lighten(@dark-secondary, 8%) !important;
      }
    }
  }

  &__filter {
    &--done {
      background-color: @dark-secondary !important;
      color: @white-color !important;

      &:hover {
        background-color: @dark-secondary !important;
        color: @white-color !important;
      }
    }
  }
}</style>
